import { createAction, props } from '@ngrx/store';
import { MwLoadOptions } from 'app/models/load-options.model';
import { MwPayloadModel } from 'app/models/payload.model';
import { CustomerProjectApiModel } from 'app/models/customer-project-api.model';

export const loadCustomerProjects = createAction(
  '[CustomerProjects] Load',
  props<{ loadOptions: MwLoadOptions }>()
);

export const loadCustomerProjectsSuccess = createAction(
  '[CustomerProjects] Load Successful',
  props<{ response: MwPayloadModel<CustomerProjectApiModel[]> }>()
);

export const loadCustomerProjectsFailed = createAction(
  '[CustomerProjects] Load Failed',
  props<{ error: any }>()
);

export const createCustomerProject = createAction(
  '[CustomerProjects] Create',
  props<{ customerProject: CustomerProjectApiModel }>()
);

export const createCustomerProjectSuccess = createAction(
  '[CustomerProjects] Create Successful'
);

export const createCustomerProjectFailed = createAction(
  '[CustomerProjects] Create Failed',
  props<{ error: any }>()
);

export const updateCustomerProject = createAction(
  '[CustomerProjects] Update',
  props<{ customerProject: CustomerProjectApiModel }>()
);

export const updateCustomerProjectSuccess = createAction(
  '[CustomerProjects] Update Successful'
);

export const updateCustomerProjectFailed = createAction(
  '[CustomerProjects] Update Failed',
  props<{ error: any }>()
);

export const deleteCustomerProject = createAction(
  '[CustomerProjects] Delete',
  props<{ customerProject: CustomerProjectApiModel }>()
);

export const deleteCustomerProjectSuccess = createAction(
  '[CustomerProjects] Delete Successful'
);

export const deleteCustomerProjectFailed = createAction(
  '[CustomerProjects] Delete Failed',
  props<{ error: any }>()
);

export const deleteCustomerProjectsList = createAction(
  '[CustomerProjects] Delete List',
  props<{ customerProjects: CustomerProjectApiModel[] }>()
);

export const deleteCustomerProjectsListSuccess = createAction(
  '[CustomerProjects] Delete List Successful'
);

export const deleteCustomerProjectsListFailed = createAction(
  '[CustomerProjects] Delete List Failed',
  props<{ error: any }>()
);

export const resetCustomerProjects = createAction('[CustomerProjects] Reset');
